// tslint:disable: completed-docs
import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';
import {
    NAMESPACE,
} from '../../constant';

import { createStructuredSelector } from 'reselect';
import {
    selectLoading,
    selectAddressFailed,
    selectError,
    selectInitAddressForm,
    selectFormData,
    selectorResponseData,
} from './selector';
import reducer from './reducer';
import GlasfaserVfpSaga from './saga';
import {
    initApp,
    initForm,
    getAddress,
    saveFormDataValues,
    trackInitialPageView,
} from './action';
import { RootState } from './types';
import {
    updateGlasfaserVfpFormular,
    createFormular,
    mountNotifications,
} from './helpers/render';
import { initResetFormularButtons } from './helpers/renderButton';

import './style.scss';

interface StateProps {
    loading: boolean;
    error: boolean;
    addressNotFound: boolean;
    initAddressForm: boolean;
    responseData: {};
    formData: {
        zipcode: number,
        city: string,
        street: string,
        houseNumber: string,
    };
}

/**
 * GlasfaserVfp function
 */
function glasfaserVfp (state: StateProps, action) {

    injectReducer(NAMESPACE, reducer);
    injectSaga(NAMESPACE, GlasfaserVfpSaga);

    createFormular(action);
    initResetFormularButtons(action);
    mountNotifications();

    action.initForm();
    action.initApp();

    return {
        /**
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState) {

            updateGlasfaserVfpFormular(newState);

        },
    };
}
const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    loading: selectLoading(),
    addressNotFound: selectAddressFailed(),
    error: selectError(),
    initAddressForm: selectInitAddressForm(),
    formData: selectFormData(),
    responseData: selectorResponseData(),
});
const mapDispatch = {
    initApp,
    initForm,
    getAddress,
    saveFormDataValues,
    trackInitialPageView,
};

const GlasfaserVfp = connect(mapStateToProps, mapDispatch)(glasfaserVfp);
export default GlasfaserVfp;
